// Ilustraciones SVG originales de "Aventura Espacial".
// Usan las variables del tema para coordinarse con cada paleta.
// No representan personajes comerciales.

const ESTRELLAS = [
  { left: "8%", top: "12%", s: 1, d: 0 },
  { left: "20%", top: "66%", s: 0.7, d: 1.1 },
  { left: "34%", top: "8%", s: 0.9, d: 2.2 },
  { left: "55%", top: "5%", s: 0.6, d: 0.6 },
  { left: "68%", top: "70%", s: 1, d: 1.6 },
  { left: "82%", top: "14%", s: 0.8, d: 2.8 },
  { left: "92%", top: "52%", s: 0.7, d: 0.3 },
  { left: "46%", top: "82%", s: 0.8, d: 2 },
  { left: "12%", top: "88%", s: 0.6, d: 1.3 },
  { left: "90%", top: "86%", s: 0.9, d: 2.5 },
];

export function Estrellas() {
  return (
    <div className="kx-estrellas" aria-hidden="true">
      {ESTRELLAS.map((e, i) => (
        <span
          key={i}
          className="kx-estrella"
          style={{
            left: e.left,
            top: e.top,
            transform: `scale(${e.s})`,
            animationDelay: `${e.d}s`,
          }}
        />
      ))}
    </div>
  );
}

export function Cohete() {
  return (
    <svg className="kx-cohete" viewBox="0 0 120 220" aria-hidden="true">
      {/* llama */}
      <path className="kx-cohete-llama" d="M60 186 Q48 206 60 218 Q72 206 60 186 Z" fill="var(--kx-acento)" />
      {/* aletas */}
      <path d="M38 132 Q18 152 22 178 L42 168 Z" fill="var(--kx-terciario)" />
      <path d="M82 132 Q102 152 98 178 L78 168 Z" fill="var(--kx-terciario)" />
      {/* cuerpo */}
      <path d="M60 8 Q90 42 88 110 L86 170 Q60 184 34 170 L32 110 Q30 42 60 8 Z" fill="var(--kx-primario)" />
      {/* ventana */}
      <circle cx="60" cy="86" r="17" fill="var(--kx-fondo)" stroke="var(--kx-texto)" strokeWidth="4" />
      <circle cx="60" cy="86" r="7" fill="var(--kx-acento)" />
      {/* punta */}
      <path d="M60 8 Q74 24 82 44 L38 44 Q46 24 60 8 Z" fill="var(--kx-acento)" />
    </svg>
  );
}

export function Planeta({ numero, texto }) {
  return (
    <div className="kx-planeta" data-testid="kx-edad">
      <span className="kx-planeta-anillo" aria-hidden="true" />
      <span className="kx-planeta-cuerpo">
        <span className="kx-planeta-numero">{numero}</span>
        <span className="kx-planeta-texto">{texto}</span>
      </span>
    </div>
  );
}
